import React, { useState, useEffect } from 'react';
import { API_URL } from '../../config';

/**
 * Badge vert/rouge en bas à droite indiquant si le backend répond
 * Vérifie toutes les 60 secondes
 */
export default function ApiStatusBadge() {
  const [status, setStatus] = useState('checking'); // checking | ok | error

  const check = async () => {
    try {
      const controller = new AbortController();
      const tid = setTimeout(() => controller.abort(), 5000);
      const res = await fetch(`${API_URL}/health`, { method: 'GET', signal: controller.signal });
      clearTimeout(tid);
      setStatus(res.ok ? 'ok' : 'error');
    } catch {
      setStatus('error');
    }
  };

  useEffect(() => {
    check();
    const interval = setInterval(check, 60000);
    return () => clearInterval(interval);
  }, []);

  // N'afficher que sur les pages dashboard (pas sur le site public)
  const isDashboard = window.location.pathname.startsWith('/admin') ||
    window.location.pathname.startsWith('/tech') ||
    window.location.pathname.startsWith('/moderator') ||
    window.location.pathname.startsWith('/client');

  if (!isDashboard) return null;
  if (status === 'checking') return null;
  if (status === 'ok' && window.matchMedia && window.matchMedia('(max-width: 768px)').matches) return null; // dans l'appli : affiché seulement en cas de problème

  return (
    <div style={{
      position: 'fixed', bottom: 16, left: 16, zIndex: 9000,
      display: 'flex', alignItems: 'center', gap: 6,
      background: status === 'ok' ? '#f0fdf4' : '#fef2f2',
      border: `1px solid ${status === 'ok' ? '#bbf7d0' : '#fecaca'}`,
      borderRadius: 20, padding: '4px 10px',
      fontSize: 11, fontWeight: 600,
      color: status === 'ok' ? '#059669' : '#dc2626',
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
      cursor: 'pointer',
      transition: 'all 0.3s'
    }}
      onClick={check}
      title={status === 'ok' ? 'API opérationnelle — cliquer pour vérifier' : 'API non disponible — cliquer pour réessayer'}
    >
      <div style={{
        width: 7, height: 7, borderRadius: '50%',
        background: status === 'ok' ? '#059669' : '#dc2626',
        animation: status === 'ok' ? 'none' : 'blink 1s infinite'
      }} />
      {status === 'ok' ? 'API OK' : 'API Hors ligne'}
      <style>{`@keyframes blink{0%,100%{opacity:1}50%{opacity:0.3}}`}</style>
    </div>
  );
}
